import { proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { InvestorsResponse, NasdaqPrivateMarketListResponse, NasdaqPrivateMarketPricingResponse } from '../entities';
import { InvestorsEnvironment } from '../environment';
import { investorsRoutes } from './routes';

export class InvestorsRestful extends RestfulClient {
  constructor(session: Session) {
    const env = session.getEnvironment(InvestorsEnvironment);
    super(env.url, session, undefined, proxyClientOptions());
  }

  getCompanies = (symbol: string): SafePromise<NasdaqPrivateMarketListResponse> => {
    return this.getNasdaqPrivateMarket(investorsRoutes.companies, symbol);
  };

  getFunding = (symbol: string): SafePromise<NasdaqPrivateMarketListResponse> => {
    return this.getNasdaqPrivateMarket(investorsRoutes.funding, symbol);
  };

  getInvestors = (symbol: string): SafePromise<InvestorsResponse> => {
    return this.getNasdaqPrivateMarket(investorsRoutes.investors, symbol);
  };

  getManagement = (symbol: string): SafePromise<NasdaqPrivateMarketListResponse> => {
    return this.getNasdaqPrivateMarket(investorsRoutes.management, symbol);
  };

  getPricing = (symbol: string): SafePromise<NasdaqPrivateMarketPricingResponse> => {
    return this.getNasdaqPrivateMarket(investorsRoutes.pricing, symbol);
  };

  private getNasdaqPrivateMarket = <T>(route: { proxy: string; upstream: string }, symbol: string): SafePromise<T> => {
    const path = this.routePath(route);
    const url = this.URL(path, { symbol, ...this.upstreamAuthParams() });
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      headers: this.upstreamAuthHeaders(),
    });
  };

  private upstreamAuthHeaders = (): Record<string, string> | undefined => {
    if (this.usingProxy) return undefined;
    const env = this.session.getEnvironment(InvestorsEnvironment);
    const bearer = env.token || env.key;
    return bearer ? { Authorization: `Bearer ${bearer}` } : undefined;
  };

  private upstreamAuthParams = (): Record<string, string> | undefined => {
    if (this.usingProxy) return undefined;
    const env = this.session.getEnvironment(InvestorsEnvironment);
    return env.key ? { apikey: env.key } : undefined;
  };
}
